import React, { useContext } from 'react';

import styled from 'styled-components';

import { ListContext } from '@contexts/ListContext';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import {
    useContactsSelector,
    useContactsSelectorDispatch,
} from '@components/ContactsSelector/Common/ContactsSelectorContext';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    display: flex;
    font-size: 0.8em;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    .texts-wrapper {
        flex: 1 1 0;
        .label {
            font-weight: bold;
        }
        .value {
            padding-left: 1rem;
            span {
                display: block;
            }
        }
    }
    .remove-button-wrapper {
        font-size: 1rem;
    }
`;

const ModelAgencySelectedFilterItems = () => {
    const { selection } = useContactsSelector();
    const cs_dispatch = useContactsSelectorDispatch();
    const { filters } = selection;

    const { GetCountry } = useContext(ListContext);

    const getCountryName = (code) => {
        const country = GetCountry(code);
        return country ? country.Name : code;
    };

    const removeAllAgencyFiltersFromWorkingFilters = () => {
        const newWorkingFilters = filters.active.filter((f) => f.area !== 'agency');
        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
        cs_dispatch({ type: 'ApplyWorkingFilters' });
    };

    const removeRepresentedFilterFromWorkingFilters = () => {
        const newWorkingFilters = filters.active.filter((f) => f.name !== 'Represented');
        cs_dispatch({ type: 'ChangeFilters', filters: newWorkingFilters });
        cs_dispatch({ type: 'ApplyWorkingFilters' });
    };

    let agencytext = '';
    const agencynotin = filters.active.find((f) => f.name === 'AgencyNotIn');
    const agencyid = filters.active.find((f) => f.name === 'AgencyID');
    const agencytype = filters.active.find((f) => f.name === 'AgencyType');
    const agencycities = filters.active.find((f) => f.name === 'AgencyCities');
    const agencycountry = filters.active.find((f) => f.name === 'AgencyCountry');
    const represented = filters.active.find((f) => f.name === 'Represented');

    const AgencyText = () => {
        if (agencytype || agencyid || agencycities || agencycountry) {
            if (agencynotin && agencynotin.value) {
                agencytext = 'Models not linked to ';
            } else {
                agencytext = 'Models linked to ';
            }
            if (agencyid && agencyid.value) {
                agencytext += getContactName(agencyid.value);
            } else {
                agencytext += ' any agency';
            }
            if (agencytype && agencytype.value) {
                agencytext += ` as ${agencytype.value}`;
            }
            if (agencycities && agencycities.value) {
                agencytext += ` in ${agencycities.value}`;
            }
            if (agencycountry && agencycountry.value) {
                agencytext += ` in ${getCountryName(agencycountry.value)}`;
            }
            return (
                <Wrapper>
                    <div className="texts-wrapper">
                        <div className="label">Agencies</div>
                        <div className="value">{agencytext}</div>
                    </div>
                    <div className="remove-button-wrapper">
                        <NwIcon
                            pointer
                            icon={byPrefixAndName.fasl['times']}
                            onClick={removeAllAgencyFiltersFromWorkingFilters}
                        />
                    </div>
                </Wrapper>
            );
        }
        return <></>;
    };

    const RepresentedText = () => {
        if (represented) {
            return (
                <Wrapper>
                    <div className="texts-wrapper">
                        <div className="label">Represented</div>
                        <div className="value">{represented.value ? 'yes' : 'no'}</div>
                    </div>
                    <div className="remove-button-wrapper">
                        <NwIcon
                            pointer
                            icon={byPrefixAndName.fasl['times']}
                            onClick={removeRepresentedFilterFromWorkingFilters}
                        />
                    </div>
                </Wrapper>
            );
        }
        return <></>;
    };

    return (
        <>
            <AgencyText />
            <RepresentedText />
        </>
    );
};

export default ModelAgencySelectedFilterItems;
